<template>
  <Modal class="packs-processing" icon="like" :title="$t('packs.processing.title')" @close="close">
    <template #text>
      <div class="packs-processing__body">
        <p class="packs-processing__text">{{ $t('packs.processing.text') }}</p>
        <div class="packs-processing__note" v-html="$t('packs.processing.note')" />
        <i18n path="packs.processing.track" tag="p" class="packs-processing__track">
          <template #here>
            <a href="https://www.roblox.com/transactions" target="_blank">{{ $t('transfer.here') }}</a>
          </template>
        </i18n>
      </div>
    </template>
    <template #footer>
      <Button right-icon="/transfer/arrow-right.svg" @click="close">
        {{ $t('actions.close') }}
      </Button>
    </template>
  </Modal>
</template>

<script>
import Modal from '@/components/Base/Modal/modal.vue'
import Button from '@/components/Base/Button/Button.vue'

export default {
  name: 'PacksProcessing',
  components: { Modal, Button },
  methods: {
    close() {
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss" scoped>
.packs-processing {
  // Меньше пустого места сверху (как в остальных модалках паков)
  ::v-deep .modal__actions {
    margin-bottom: 4px;
  }

  ::v-deep .modal__close {
    height: 40px;
  }

  &__body {
    display: flex;
    flex-direction: column;
    gap: 12px;
    text-align: center;
    margin-bottom: 24px;
  }

  &__text {
    font-size: 18px;
    font-weight: 600;
    line-height: 120%;
    color: var(--main-8);
  }

  &__note {
    font-size: 14px;
    line-height: 140%;
    color: #8a8a8a;
  }

  &__track {
    font-size: 14px;
    color: #8a8a8a;

    a {
      color: #0077c3;
    }
  }
}
</style>
